import Footer from "../footer";
import NavBar from "../navbar";
import { Link } from "react-router-dom";
import TransferBanner from "../../assets/transfer-playlist.png"
import VerifyTransferBanner from "../../assets/verify-transfer.png"
import AddMissingBanner from "../../assets/add-missing-tracks.png"

import config from "../../config";

import { CloudArrowUpIcon, LockClosedIcon, ServerIcon } from '@heroicons/react/20/solid'

import {
    ArrowLeftStartOnRectangleIcon,
    ArrowPathIcon,
    ArrowsRightLeftIcon,
    CheckBadgeIcon,
    MusicalNoteIcon,
    UserIcon
  } from '@heroicons/react/20/solid';


function MissingTracks() {

    const features = [
        {
            name: 'Open transfer history: ',
            description: 'In the transfer history page, select add missing tracks.',
        },
        {
            name: 'Select missing tracks: ',
            description: 'Select the songs missed from the dropdown, from the add missing tracks view.',
        },
        {
            name: 'Search and add: ',
            description: 'Change the search keywords, search and add missing tracks.',
        },
    ]


    return (

        <>

            <div className="max-w-screen-xl px-4 py-8 mx-auto space-y-12 lg:space-y-20 lg:py-24 lg:px-6">

                {/* Row */}
                <div className="items-center gap-8 lg:grid lg:grid-cols-2 xl:gap-16">
                    <div className="text-gray-500 sm:text-lg dark:text-gray-400">

                        <div className="lg:row-start-2 lg:max-w-md">
                            <h2 className="text-3xl font-semibold tracking-tight text-balance text-gray-900 dark:text-white sm:text-4xl">
                                Add missing track
                            </h2>
                            <p className="mt-6 text-lg/8 text-gray-500 sm:text-xl dark:text-gray-400">
                                Sometimes metadata do not match across services, and some tracks missing be missing. Use our Add missing track feature to quickly add them.
                            </p>
                            
                        </div>
                        
                        <div className="pt-4 max-w-xl lg:row-start-3 lg:mt-10 lg:max-w-md lg:border-t lg:border-white/10 lg:pt-10">
                            <dl className="max-w-xl space-y-8 text-base/7 text-gray-300 lg:max-w-none">

                            {features.map((feature) => (
                            <div key={feature.name} className="">
                                <dt className="inline-block font-semibold text-gray-900 dark:text-white">
                                    <span>{feature.name}</span>
                                </dt>{' '}
                            <dd className="inline text-gray-500 dark:text-gray-400">{feature.description}</dd>
                            </div>
                            ))}

                            </dl>
                        </div>

                    </div>
                    <img
                        className="pt-4 w-full mb-4 rounded-lg lg:mb-0 lg:flex"
                        src={AddMissingBanner}
                        alt="Transfer Playlists, albums and favourite songs"
                    />
                </div>
            </div>




        </>
    )
}



function VerifyTransfer() {

    const features = [
        {
            name: 'Select Verify and Transfer: ',
            description: 'Click Verify and Transfer during the transfer.',
        },
        {
            name: 'Verify matches: ',
            description: 'Once the matches are found, select "Verify and Transfer" from the transfer history.',
        },
        {
            name: 'Edit your matches: ',
            description: 'Verify your matches and add missing ones. You can ignore if you can\'t find a matching track.',
        },
    ]


    return (

        <>

            <div className="max-w-screen-xl px-4 py-8 mx-auto space-y-12 lg:space-y-20 lg:py-24 lg:px-6">

                {/* Row */}
                <div className="items-center gap-8 lg:grid lg:grid-cols-2 xl:gap-16">
                    <div className="text-gray-500 sm:text-lg dark:text-gray-400">

                        <div className="lg:row-start-2 lg:max-w-md">
                            <h2 className="text-3xl font-semibold tracking-tight text-balance text-gray-900 dark:text-white sm:text-4xl">
                                Verify and Transfer
                            </h2>
                            <p className="mt-6 text-lg/8 text-gray-500 sm:text-xl dark:text-gray-400">
                                Use our verify and transfer feature to fix the matches even before the transfer.
                            </p>
                            
                        </div>
                        
                        <div className="pt-4 max-w-xl lg:row-start-3 lg:mt-10 lg:max-w-md lg:border-t lg:border-white/10 lg:pt-10">
                            <dl className="max-w-xl space-y-8 text-base/7 text-gray-300 lg:max-w-none">

                            {features.map((feature) => (
                            <div key={feature.name} className="">
                                <dt className="inline-block font-semibold text-gray-900 dark:text-white">
                                    <span>{feature.name}</span>
                                </dt>{' '}
                            <dd className="inline text-gray-500 dark:text-gray-400">{feature.description}</dd>
                            </div>
                            ))}

                            </dl>
                        </div>

                    </div>
                    <img
                        className="pt-4 w-full mb-4 rounded-lg lg:mb-0 lg:flex"
                        src={VerifyTransferBanner}
                        alt="Transfer Playlists, albums and favourite songs"
                    />
                </div>
            </div>

        </>
    )
}



function TransferFeature() {

    const features = [
        {
            name: 'Connect your music accounts: ',
            description: 'Click Add account to connect your source and destination accounts.',
        },
        {
            name: 'Select the playlists/albums: ',
            description: 'Select the source and choose the albums, playlists and saved tracks you want to transfer.',
        },
        {
            name: 'Select target account: ',
            description: 'Click transfer and choose the target account.',
        },
    ]


    return (

        <>

            <div className="max-w-screen-xl px-4 py-8 mx-auto space-y-12 lg:space-y-20 lg:py-24 lg:px-6">

                {/* Row */}
                <div className="items-center gap-8 lg:grid lg:grid-cols-2 xl:gap-16">
                    <div className="text-gray-500 sm:text-lg dark:text-gray-400">

                        <div className="lg:row-start-2 lg:max-w-md">
                            <h2 className="text-3xl font-semibold tracking-tight text-balance text-gray-900 dark:text-white sm:text-4xl">
                                Transfer your songs in 3 steps
                            </h2>
                            <p className="mt-6 text-lg/8 text-gray-500 sm:text-xl dark:text-gray-400">
                                
                            </p>
                        
                        </div>
                        
                        <div className="pt-4 max-w-xl lg:row-start-3 lg:mt-10 lg:max-w-md lg:border-t lg:border-white/10 lg:pt-10">
                            <dl className="max-w-xl space-y-8 text-base/7 text-gray-300 lg:max-w-none">

                            {features.map((feature) => (
                            <div key={feature.name} className="">
                                <dt className="inline-block font-semibold text-gray-900 dark:text-white">
                                    <span>{feature.name}</span>
                                </dt>{' '}
                            <dd className="inline text-gray-500 dark:text-gray-400">{feature.description}</dd>
                            </div>
                            ))}

                            </dl>
                        </div>


                    </div>
                    <img
                        className="pt-4 w-full mb-4 rounded-lg lg:mb-0 lg:flex"
                        src={TransferBanner}
                        alt="Transfer Playlists, albums and favourite songs"
                    />
                </div>
            </div>

        </>
    )
}



export default function Transfer() {
    return (

        <>

            {/* {Navbar} */}
            <NavBar selected={"transfer"}></NavBar>


            <>
                {/* Start block */}
                <section className="bg-white dark:bg-zinc-950">
                    <div className="max-w-screen-xl pt-20 px-4 py-8 mx-auto lg:py-24 lg:px-6 lg:pt-28">
                        <div className="max-w-screen-md mx-auto mb-8 text-center lg:mb-12">
                            <h2 className="mb-4 text-3xl font-extrabold tracking-tight text-gray-900 dark:text-white">
                                Transfer your playlists, albums and tracks across platforms
                            </h2>
                            <p className="mb-5 font-light text-gray-500 sm:text-xl dark:text-gray-400">
                                With our powerful features transfer your playlists in 3 clicks, fix the transfer with right matches and add missing tracks.
                            </p>
                        </div>
                    </div>
                </section>
                {/* End block */}
            </>




            { }

            <section className="bg-white dark:bg-zinc-800">
                <TransferFeature></TransferFeature>
            </section>


            <section className="bg-gray-50 dark:bg-zinc-950">
                <MissingTracks></MissingTracks>
            </section>


            <section className="bg-white dark:bg-zinc-800">
                <VerifyTransfer></VerifyTransfer>
            </section>
            { }




            {/* Start block */}
            <section className="bg-gray-50 dark:bg-zinc-950">
                <div className="max-w-screen-xl px-4 py-8 mx-auto lg:py-16 lg:px-6">
                    <div className="max-w-screen-sm mx-auto text-center">
                        <h2 className="mb-4 text-3xl font-extrabold leading-tight tracking-tight text-gray-900 dark:text-white">
                            Start your transfer for free
                        </h2>
                        <p className="mb-6 font-light text-gray-500 dark:text-gray-400 md:text-lg">

                        </p>
                        <a
                            href={config.signupPath}
                            className="text-white bg-purple-700 hover:bg-purple-800 focus:ring-4 focus:ring-purple-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-purple-600 dark:hover:bg-purple-700 focus:outline-none dark:focus:ring-purple-800"
                        >
                            Sign up
                        </a>
                    </div>
                </div>
            </section>

            <Footer></Footer>
        </>
    )
}